import React from 'react';
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const StatusBadge = ({ status }) => {
  const normalizedStatus = status
    ? status.trim().charAt(0).toUpperCase() + status.trim().slice(1).toLowerCase()
    : 'Unknown';

  const statusConfig = {
    'Present': {
      icon: <CheckCircleIcon fontSize="small" />,
      bgColor: '#e8f5e9',
      textColor: '#4caf50'
    },
    'Absent': {
      icon: <CancelIcon fontSize="small" />,
      bgColor: '#ffebee',
      textColor: '#f44336'
    },
    'On Leave': {
      icon: <BeachAccessIcon fontSize="small" />,
      bgColor: '#e3f2fd',
      textColor: '#2196f3'
    },
    'Half Day': {
      icon: <AccessTimeIcon fontSize="small" />,
      bgColor: '#fff3e0',
      textColor: '#fb8c00'
    },
    'Work From Home': {
      icon: <HomeWorkIcon fontSize="small" />,
      bgColor: '#ede7f6',
      textColor: '#673ab7'
    }
  };

  const config = statusConfig[normalizedStatus] || {
    icon: <HelpOutlineIcon fontSize="small" />,
    bgColor: '#f5f5f5',
    textColor: '#9e9e9e'
  };

  return (
    <Chip
      icon={config.icon}
      label={normalizedStatus}
      sx={{
        backgroundColor: config.bgColor,
        color: config.textColor,
        fontWeight: 600,
        minWidth: '130px',
        '.MuiChip-icon': {
          color: config.textColor,
          marginLeft: '4px'
        }
      }}
      size="small"
    />
  );
};

export default StatusBadge;
